import React from 'react';
import Big from 'big.js';
import AmountInput from '@alfa-retail-react/components/amount-input';
import { useController } from 'react-hook-form';
import { observer } from 'mobx-react';
import { useFormContext } from '@alfa-retail-react/components/form-hook';

import { WEB_VISOR_HIDE } from 'app/utils/AnalyticsUtils';
import { EmploymentFormValues } from 'app/logic/pages/employment/EmploymentPage';
import { ValidationRules } from 'app/form/ValidationRules';
import { EmploymentFormStore } from 'app/logic/pages/employment/EmploymentFormStore';

export interface MonthIncomeFormItemProps {
    formStore: EmploymentFormStore;
}

export const MonthIncomeFormItem = observer(
    ({ formStore }: MonthIncomeFormItemProps) => {
        const MONTH_INCOME_FORM_ITEM_NAME = 'incomeAmount';

        const { control, handleMultipleErrors, setFieldElement } =
            useFormContext<EmploymentFormValues>();
        const { field, fieldState } = useController<EmploymentFormValues>({
            name: MONTH_INCOME_FORM_ITEM_NAME,
            control,
            defaultValue: formStore.incomeAmount?.toNumber() ?? '',
            rules: { 
                required: ValidationRules.required(),
                min: ValidationRules.min(1),
            },
        });

        const value =
            typeof field.value === 'string'
                ? ''
                : (field.value as number) * 100;

        return (
            <AmountInput
                className={WEB_VISOR_HIDE}
                ref={(element) => {
                    field.ref(element);
                    setFieldElement(MONTH_INCOME_FORM_ITEM_NAME, element);
                }}
                size="l"
                value={value}
                error={handleMultipleErrors(fieldState.error)}
                label={'Ежемесячный доход'}
                onBlur={field.onBlur}
                hint={
                    'Укажите ваш среднемесячный доход за последние 3 месяца по основному месту работы после вычета налогов'
                }
                integerLength={13}
                minority={100}
                suffix={'BYN'}
                clear
                onClear={() => {
                    formStore.incomeAmount = null;
                    field.onChange('');
                }}
                onChange={(event, payload) => {
                    let result;

                    if (typeof payload.value === 'number') {
                        result = (payload.value as number) / 100;
                        formStore.incomeAmount = new Big(result);
                    } else {
                        result = '';
                        formStore.incomeAmount = null;
                    }

                    field.onChange(result);
                }}
            />
        );
    },
);
